import { AfterViewInit, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { Observable, Subject, Subscription } from "rxjs";
import { debounceTime, map, startWith } from "rxjs/operators";
import { Misc } from "../util/misc";
import { ToastrComponent } from "../util/toastr/toastr.component";
import { EstimativaParceiroService } from "src/app/services/estimativa-parceiro.service";
import { ParceirosService } from "src/app/services/parceiros.service";
import { ParceiroEstimativaView } from "src/app/models/parceiro-estimativa-view.model";
import { ModalAbaParceiroComponent } from "./modal-estimativa/modal-aba-parceiro/modal-aba-parceiro.component";
import { MatDialog } from "@angular/material/dialog";
import { ParametroParceiroService } from "src/app/services/parametro-parceiro.service";
import { EditarParceiroEstimativaDialogComponent } from "./editar-parceiro-estimativa-dalog/editar-parceiro-estimativa.component";
import { EstimativaService } from "src/app/services/estimativa.service";
import * as constants from 'src/app/models/constants/constants';

@Component({
  selector: "app-aba-parceiros",
  templateUrl: "./aba-parceiros.component.html",
  styleUrls: ["./aba-parceiros.component.scss"],
})
export class AbaParceirosComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() estimativaId;
  @Input() somenteLeitura;
  @Input() hiddenResume: boolean;

  public keyUp = new Subject<MouseEvent>();

  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();

  loading: boolean;

  displayedColumns: string[] = [
    "delete",
    "editar",
    "parceiro",
    "solucao",
    "quantidade",
    "valor",
    "valorTotal",
    "totalVenda",
  ];
  dataSource = new MatTableDataSource<ParceiroEstimativaView>();
  totalValor = 0;
  basicForm: UntypedFormGroup;
  estimativaTipo: number;
  tipoDelivery: boolean;
  dataparceiro: any;
  listaCadParceiro: any[];
  filteredOptions: Observable<any[]>;
  idParceiroSelected;
  parceiroEstimativaSubscription: Subscription | any;
  parametroParceiroSelected: object;
  parametroImportados;
  somarValorTotal = [];
  soma: number = null;
  habilita: any;

  constructor(
    private fb: UntypedFormBuilder,
    private toastr: ToastrComponent,
    public misc: Misc,
    private dialog: MatDialog,
    public estimativa_ParcService: EstimativaParceiroService,
    public parceiroservice: ParceirosService,
    public parametroParceiroService: ParametroParceiroService,
    private estimativaService: EstimativaService,
  ) {
    this.createForm();

    const subscription = this.keyUp
      .pipe(debounceTime(250))
      .subscribe((result) => {
        this.enterSave();
      });
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.carregarTela();
  }

  carregarTela() {
    this.loading = true;

    this.loadParceiros();

    this.listarParceiro();
    this.parametroParceiroService.valoresParametros.subscribe(
      (val) => {
        this.loading = true;

        this.parametroImportados = val;
        this.enterSave();
      },
      () =>
        this.misc.processError("Não foi possivel carregar a lista de Parceiros")
    );

    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe((result: any) => {

      this.estimativaTipo = result.estimativaTipoId;
      if (this.estimativaTipo == 3) {
        this.somenteLeitura = false;
        this.tipoDelivery = true;
        this.hiddenResume;
      }

      this.estimativaService.getById(this.estimativaId).subscribe((estimativa: any) => {
        if (estimativa.statusId === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
          this.somenteLeitura = true;
          console.log("this.somenteLeitura", this.somenteLeitura)
        }
      });

    })

    this.loading = false;
  }

  ngOnDestroy(): void {
    this.parceiroEstimativaSubscription.unsubscribe();
  }

  private _filter(value: any) {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.listaCadParceiro.filter(option => option.nome.toLowerCase().includes(filterValue));
    }
  }

  createForm() {
    this.basicForm = this.fb.group({
      parceiro: [null, Validators.required],
      solucao: [null, Validators.required],
      quantidade: [null, Validators.required],
      valor: [null, Validators.required],
    });
  }

  resetForm() {
    this.basicForm.reset({
      parceiro: [null],
      solucao: [null],
      quantidade: [null],
      valor: [null],
      emitEvent: false,
    });

    (
      document.getElementById(
        "btnAdicionarCustosAdicionais"
      ) as HTMLButtonElement
    ).disabled = true;

    (document.getElementById("inputValor") as HTMLInputElement).value = "";
  }

  enterClick(event: KeyboardEvent) {
    event.preventDefault();

    if (event.keyCode === 13) {
      this.enterSave();
    }
  }

  enterSave() {
    if (!this.basicForm.valid && this.basicForm.get("parceiro").value) {
      return;
    }

    this.save();
  }

  save() {
    this.loading = true;
    let solucaoSelect = this.basicForm.get("solucao").value;
    let quantidadeSelect = this.basicForm.get("quantidade").value;
    let valorSelect = this.basicForm.get("valor").value;

    const parametroParceiroForm = this.basicForm.getRawValue();
    if (Number(parametroParceiroForm.quantidade) < 0) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção",
        "A quantidade não pode ser menor ou igual a zero."
      );

      return;
    }

    if (Number(parametroParceiroForm.valor) < 0) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção",
        "O Valor não pode ser menor ou igual a zero."
      );

      return;
    }

    if (!solucaoSelect && !quantidadeSelect && !valorSelect) {
      console.log(solucaoSelect, quantidadeSelect, valorSelect);
      return;
    }

    parametroParceiroForm.estimativaId = this.estimativaId;
    let NovoParceiro = {
      parceiroId: this.idParceiroSelected,
      estimativaId: this.estimativaId,
      solucao: solucaoSelect,
      quantidade: quantidadeSelect,
      valor: valorSelect,
      pAdministrativo: this.parametroImportados.administrativo,
      pComissao: this.parametroImportados.comissao,
      pImposto: this.parametroImportados.impostos,
      pInvestimento: this.parametroImportados.investimento,
      pMargemLiquida: this.parametroImportados.margemLiquida,
    };

    this.estimativa_ParcService.criaEstimativaParceiro(NovoParceiro).subscribe(
      (result: any) => {
        this.toastr.mostrarMensagem(
          "sucesso",
          "Informação",
          "Parceiro adicionado com sucesso!"
        );

        this.loadParceiros();
        this.listarParceiro();
        this.resetForm();
      },
      (error) => {
        this.misc.processError("Tivemos um Erro ao Adcionar parceiro.");
      }
    );
    this.loading = false;
  }

  excluir(parceiroEstimativaId) {
    this.loading = true;

    this.estimativa_ParcService
      .deleteEstimativaParceiro(parceiroEstimativaId.id)
      .subscribe(
        (result) => {
          this.toastr.mostrarMensagem(
            "sucesso",
            "Informação",
            "Excluído com sucesso!"
          );

          this.loadParceiros();
          this.calculaTotal();
        },
        (error) => {
          this.misc.processError("Tivemos um erro ao excluir o Parceiro.");
        }
      )
      .add(() => {
        setTimeout(() => (this.loading = false), 600);
      });
  }

  calculaTotal() {
    this.soma = this.somarValorTotal.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
  }

  loadParceiros() {
    this.somarValorTotal = [];

    this.parceiroEstimativaSubscription = this.estimativa_ParcService
      .getOneEstimativaParceiros(this.estimativaId)
      .subscribe(
        (result: any) => {
          if (result.items) {
            this.dataparceiro = result.items;
            this.dataparceiro.sort((a, b) => a.id - b.id).reverse();
            this.dataparceiro.sort((item, valor) => {
              item.solucao - valor.solucao;
            });

            this.dataparceiro.forEach((el, index) => {
              this.buscaValorTotalVenda(el, index);
            });
          }

          this.dataSource = new MatTableDataSource<ParceiroEstimativaView>(
            this.dataparceiro
          );
        },
        (error) => {
          this.toastr.mostrarMensagem(
            "erro",
            "Atenção!",
            "Tivemos um erro ao carregar a lista de Parceiro."
          );
        },
        () => {
          this.loading = false;
        }
      );
  }

  public returnParceiro(parceiroid) {
    this.idParceiroSelected = parceiroid;
  }

  private listarParceiro() {
    this.parceiroEstimativaSubscription = this.parceiroservice
      .getParceirosAtivos()
      .subscribe(
        (resultParc: any) => {
          this.listaCadParceiro = resultParc.items;
          this.filteredOptions = this.basicForm.valueChanges.pipe(
            startWith(""),
            map((value) => this._filter(value.parceiro))
          );
        },

        (error) => {
          this.misc.processError("Não foi possível carregar os Parceiros.");
        }
      );
  }

  public openModalParceiroEstimativa(): void {
    const dialogRef = this.dialog.open(ModalAbaParceiroComponent, {
      width: "600px",
      panelClass: "default-dialog-container",
      data: this.idParceiroSelected,
    });
  }

  buscaValorTotalVenda(idParceiroPricing, index): any {
    this.somarValorTotal = [];
    this.loading = true;
    if (idParceiroPricing) {
      this.parceiroEstimativaSubscription = this.estimativa_ParcService
        .calculoValorVenda(idParceiroPricing.id)
        .subscribe(
          (ret) => {
            if (ret) {
              this.dataparceiro[index].totalVenda = ret;
              this.somarValorTotal.push(ret);
            }
            this.calculaTotal();
          },
          (error) => {
            this.misc.processError(
              error,
              "Não foi possivel Calcular o Total para o parceiro"
            );
          },
          () => {
            this.loading = false;
          }
        );
    }
  }

  enableSave() {
    let button = document.getElementById(
      "btnAdicionarCustosAdicionais"
    ) as HTMLButtonElement;

    let parceiro = document.getElementById("parceiro") as any;
    let solucaoid = document.getElementById("solucao") as any;
    let quantidadeid = document.getElementById("quantidade") as any;
    let valorid = document.getElementById("inputValor") as any;

    parceiro.addEventListener("keyup", () => this.habilita());
    solucaoid.addEventListener("keyup", () => this.habilita());
    quantidadeid.addEventListener("keyup", () => this.habilita());
    valorid.addEventListener("keyup", () => this.habilita());

    this.habilita = () => {
      if (
        parceiro.value &&
        solucaoid.value &&
        quantidadeid.value &&
        valorid.value
      ) {
        if (button) button.disabled = false;
      } else {
        if (button) button.disabled = true;
      }
    };
  }

  atualizarParceiroEstimativa(perceiroEstimativa: ParceiroEstimativaView = new ParceiroEstimativaView()) {
    const dialogRef = this.dialog.open(EditarParceiroEstimativaDialogComponent, {
      width: '600px',
      panelClass: 'default-dialog-container',
      data: perceiroEstimativa
    });

    dialogRef.afterClosed().subscribe(() => {
      this.carregarTela();
    });
  }
}
